export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    accountNumber = "",
    fundType = "",
    itemUnit = "",
    year = "",
    details = [],
    openingBalance = 0,
    totalDebitAmount = 0,
    totalCreditAmount = 0,
    closingBalance = 0,
    totalPages = "",
    openingDate = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let tableRows = details.map((item) => `
    <tr>
      <td class="border text-center">${item.recordingDate || ""}</td>
      <td class="border text-center">${item.docDate || ""}</td>
      <td class="border text-center">${item.receiptDocNumber || ""}</td>
      <td class="border text-center">${item.paymentDocNumber || ""}</td>
      <td class="border px-1">${item.description || ""}</td>
      <td class="border text-center">${item.offsetAccount || ""}</td>
      <td class="border text-right px-1">${fmt(item.debitAmount)}</td>
      <td class="border text-right px-1">${fmt(item.creditAmount)}</td>
      <td class="border text-right px-1 font-bold bg-light">${fmt(item.balanceAmount)}</td>
      <td class="border px-1">${item.note || ""}</td>
    </tr>
  `).join("");

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 13px; color: black; line-height: 1.5;">
      <table width="100%">
        <tr>
          <td width="40%" valign="top">
            <div class="font-bold">Đơn vị: <span class="dotted-line">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span class="dotted-line">${address}</span></div>
          </td>
          <td width="60%" align="center">
            <div class="font-bold">Mẫu số S07a-DN</div>
            <div style="font-style: italic; font-size: 12px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 25px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 18px;">SỔ KẾ TOÁN CHI TIẾT QUỸ TIỀN MẶT</h2>
        <div style="margin-top: 10px;">
          Tài khoản: <span class="dotted-line px-1 font-bold">${accountNumber}</span>
        </div>
        <div style="margin-top: 5px;">
          Loại quỹ: <span class="dotted-line px-1">${fundType}</span>
        </div>
        <div style="margin-top: 5px; font-weight: bold;">
          Năm: <span class="dotted-line px-1">${year}</span>
        </div>
      </div>
      <div style="text-align: right; font-style: italic;">Đơn vị tính: <span class="dotted-line" style="font-style: normal; font-weight: bold;">${itemUnit}</span></div>

      <table class="table-full" width="100%" style="border-collapse: collapse; margin-top: 5px;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="70">Ngày, tháng ghi sổ</th>
            <th class="border" rowspan="2" width="70">Ngày, tháng chứng từ</th>
            <th class="border" colspan="2" width="140">Số hiệu chứng từ</th>
            <th class="border" rowspan="2">Diễn giải</th>
            <th class="border" rowspan="2" width="60">TK đối ứng</th>
            <th class="border" colspan="2" width="180">Số phát sinh</th>
            <th class="border" rowspan="2" width="100">Số tồn</th>
            <th class="border" rowspan="2" width="100">Ghi chú</th>
          </tr>
          <tr>
            <th class="border" width="70">Thu</th>
            <th class="border" width="70">Chi</th>
            <th class="border" width="90">Nợ</th>
            <th class="border" width="90">Có</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">D</th>
            <th class="border">E</th>
            <th class="border">F</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3</th>
            <th class="border">G</th>
          </tr>
        </thead>
        <tbody>
          <!-- DÒNG SỐ TỒN ĐẦU KỲ -->
          <tr style="font-weight: bold;">
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border px-1">- Số tồn đầu kỳ</td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border text-right px-1 font-bold">${fmt(openingBalance)}</td>
            <td class="border"></td>
          </tr>
          
          <tr style="font-style: italic;">
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border px-1">- Số phát sinh trong kỳ</td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
          </tr>

          ${tableRows}
          
          <!-- DÒNG CỘNG SỐ PHÁT SINH TRONG KỲ -->
          <tr style="font-weight: bold; background-color: #fafafa;">
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border px-1">- Cộng số phát sinh trong kỳ</td>
            <td class="border text-center">X</td>
            <td class="border text-right px-1">${fmt(totalDebitAmount)}</td>
            <td class="border text-right px-1">${fmt(totalCreditAmount)}</td>
            <td class="border text-center">X</td>
            <td class="border text-center">X</td>
          </tr>
          
          <!-- DÒNG SỐ TỒN CUỐI KỲ -->
          <tr style="font-weight: bold; background-color: #fafafa;">
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border"></td>
            <td class="border px-1">- Số tồn cuối kỳ</td>
            <td class="border text-center">X</td>
            <td class="border text-center">X</td>
            <td class="border text-center">X</td>
            <td class="border text-right px-1 font-bold text-blue">${fmt(closingBalance)}</td>
            <td class="border text-center">X</td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top: 15px;">
        <div>- Sổ này có <span class="dotted-line">${totalPages}</span> trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: <span class="dotted-line">${openingDate}</span></div>
      </div>

      <table width="100%" style="margin-top: 30px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 12px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 60px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>

      <style>
        .border { border: 1px solid black; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .text-blue { color: blue; }
        .font-bold { font-weight: bold; }
        .px-1 { padding: 6px; }
        .bg-light { background-color: #fdfdfd; }
        .table-full { border: 1px solid black; }
        .dotted-line { border-bottom: 1px dotted black; }
      </style>
    </div>
  `;
};
